import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const fetchDowntimeList = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/getDownTimeList', METHOD_TYPES.GET, data, callback);
}

export const createDowntime = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/createDownTime', METHOD_TYPES.POST, data, callback);
}

export const updateDowntime = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/updateDownTime', METHOD_TYPES.PUT, data, callback);
}



// WEBPACK FOOTER //
// ./src/data/redux/downtime_details/api.js